<div class="birthdate-bonus-modal">
  <div class="birthdate-bonus-content">
    <div class="birthdate-bonus-image">
      <image-loader-utils url="birthdateBonus" imageFormat="png"></image-loader-utils>
    </div>
    <div class="birthdate-bonus-text">
      <div class="birthdate-bonus-text-title">{{ 'BIRTHDATE_BONUS_TITLE' | translate }}</div>
      <div class="birthdate-bonus-text-title-2">{{ 'BIRTHDATE_BONUS_TITLE_2' | translate }}</div>
      <div class="birthdate-bonus-text-desc">{{ 'BIRTHDATE_BONUS_TEXT' | translate : { currency: 20 | balanceFormat } }}</div>
    </div>
    <div class="birthdate-bonus-button" (click)="this.closeBirthdayModal()">
      <div class="birthdate-bonus-button-text">{{ 'Confirm' | translate }}</div>
    </div>
  </div>
</div>
<confetti-utils></confetti-utils>
